var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-order-info" },
    [
      _c(
        "el-form",
        {
          staticClass: "section",
          staticStyle: { "flex-direction": "row" },
          attrs: { disabled: !_vm.isEditing }
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                "align-items": "center",
                width: "64px"
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("FbaJob.ValueAddedServices")) + " ")]
          ),
          _c(
            "el-checkbox-group",
            {
              on: { change: _vm.addedServiceChangeHandler },
              model: {
                value: _vm.selectedLocalAddedService,
                callback: function($$v) {
                  _vm.selectedLocalAddedService = $$v
                },
                expression: "selectedLocalAddedService"
              }
            },
            _vm._l(_vm.localAddedService, function(item) {
              return _c(
                "el-checkbox",
                {
                  key: item.code,
                  staticStyle: { "margin-left": "8px", "margin-right": "8px" },
                  attrs: { label: item.code },
                  on: {
                    change: function(val) {
                      return _vm.singleAddedServiceChangeHandler(val, item)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(item.chineseName) + " ")]
              )
            }),
            1
          ),
          _c(
            "el-checkbox",
            {
              staticStyle: { "margin-left": "8px", "margin-right": "8px" },
              attrs: { no: "destinationPortService" },
              model: {
                value: _vm.form.destinationPortService,
                callback: function($$v) {
                  _vm.$set(_vm.form, "destinationPortService", $$v)
                },
                expression: "form.destinationPortService"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.PortOfDestinationServices")))]
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "section",
          staticStyle: { width: "80%", "min-width": "1000px" }
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.BasicInfo")))
          ]),
          _c(
            "div",
            {
              staticClass: "form-row",
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    "label-width": "80px",
                    "label-position": "right",
                    disabled: !_vm.isEditing
                  }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: { label: _vm.$t("FbaJob.BookingNo") }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.bookingNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "bookingNo", $$v)
                                  },
                                  expression: "form.bookingNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "el-form-item-w240" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ConsignationCompany")
                                    )
                                  )
                                ]
                              ),
                              _c("cargo-company-select", {
                                staticClass: "shipper-selector",
                                staticStyle: { flex: "1" },
                                attrs: {
                                  no: "customerId",
                                  "popper-class": "shipper-selector-popper",
                                  "method-params": {
                                    customer: true,
                                    active: true,
                                    fba: true
                                  },
                                  "check-credit": true,
                                  job: _vm.form,
                                  "default-value": _vm.form.customerId || "",
                                  "static-options": _vm.customerCmpList,
                                  disabled: !_vm.customerEnabled,
                                  "data-filter-function": _vm.customerIdFilter
                                },
                                on: {
                                  change: function(p) {
                                    _vm.customerIdChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "el-form-item-w240" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Sales")))]
                              ),
                              _c("cargo-user-select", {
                                ref: "sales",
                                attrs: {
                                  no: "sales",
                                  "method-params": {
                                    officeId: _vm.salesOfficeCheck
                                      ? _vm.$store.getters.currentOfficeId
                                      : "",
                                    category: "role",
                                    shape: "sales"
                                  },
                                  "default-value": _vm.form.sales || "",
                                  "static-options": _vm.salesList,
                                  "merge-load": true
                                },
                                on: {
                                  change: function(p) {
                                    _vm.salesChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: { label: _vm.$t("SeaExport.Operation") }
                            },
                            [
                              _c("cargo-user-select", {
                                ref: "op",
                                attrs: {
                                  no: "op",
                                  "method-params": {
                                    officeId: _vm.form.opOffice,
                                    category: "role",
                                    shape: "op"
                                  },
                                  "default-value": _vm.form.op || "",
                                  "merge-load": true
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.op = p.value
                                    _vm.opChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: { label: _vm.$t("SeaExport.quotationNum") }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.quotationNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "quotationNo", $$v)
                                  },
                                  expression: "form.quotationNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: {
                                label: _vm.$t("SeaExport.ContactPerson")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.customerContact,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "customerContact", $$v)
                                  },
                                  expression: "form.customerContact"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "el-form-item-w240" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.SalesDepartment"))
                                  )
                                ]
                              ),
                              _c("cargo-department-new-select", {
                                attrs: {
                                  no: "salesDepartment",
                                  disabled: !_vm.form.sales,
                                  "sales-id": Number(_vm.form.sales),
                                  "office-id": _vm.form.salesOffice,
                                  enables: true,
                                  "department-id": Number(
                                    _vm.form.salesDepartment
                                  )
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.salesDepartment = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: {
                                label: _vm.$t("SeaExport.OperationDepartment")
                              }
                            },
                            [
                              _c("cargo-department-select", {
                                attrs: {
                                  no: "opDepartment",
                                  "office-id": Number(_vm.form.opOffice),
                                  enables: true,
                                  "department-id": Number(_vm.form.opDepartment)
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.opDepartment = p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: { label: _vm.$t("SeaExport.WarehouseNo") }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.warehouseNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "warehouseNo", $$v)
                                  },
                                  expression: "form.warehouseNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: { label: _vm.$t("SeaExport.Tel") }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.contactTelephone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "contactTelephone", $$v)
                                  },
                                  expression: "form.contactTelephone"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "el-form-item-w240" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.SalesCompany"))
                                  )
                                ]
                              ),
                              _c("cargo-office-select", {
                                attrs: {
                                  no: "salesOffice",
                                  "office-id": Number(_vm.form.salesOffice)
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.salesOffice = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: {
                                label: _vm.$t("SeaExport.OperationCompany")
                              }
                            },
                            [
                              _c("cargo-office-select", {
                                attrs: {
                                  no: "opOffice",
                                  disabled: _vm.opOfficeDisabled,
                                  "office-id": Number(_vm.form.opOffice),
                                  "is-regional-commission":
                                    _vm.isRegionalCommission
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.opOffice = p.value
                                    _vm.form.opDepartment = 0
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          !_vm.isZY
                            ? _c("el-form-item", {
                                staticClass: "el-form-item-w240",
                                staticStyle: { height: "28px" }
                              })
                            : _vm._e(),
                          _vm.isZY
                            ? [
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "blue",
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.AllowSaleProduct")
                                          )
                                        )
                                      ]
                                    ),
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .basic_data_AllowSaleProduct,
                                        filterable: "",
                                        no: "allowSaleProduct",
                                        clearable: "",
                                        "data-filter-function": function(p) {
                                          return (
                                            p.statusEnabled &&
                                            (p.fbaSea ||
                                              p.fbaAir ||
                                              p.fbaRailway)
                                          )
                                        },
                                        "default-value":
                                          _vm.form.saleProductCode || ""
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.saleProductCode = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "blue",
                                        attrs: { slot: "label" },
                                        slot: "label"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.FullOrInside")
                                          )
                                        )
                                      ]
                                    ),
                                    _c("cargo-advance-select", {
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .local_cache_FullOrInside$FULL_OR_INSIDE,
                                        no: "fullOrInside",
                                        clearable: "",
                                        "default-value":
                                          _vm.form.fullOrInside || ""
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.form.fullOrInside = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: { label: _vm.$t("SeaExport.Fax") }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.contactFax,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "contactFax", $$v)
                                  },
                                  expression: "form.contactFax"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: {
                                label: _vm.$t("SeaExport.CustomerService")
                              }
                            },
                            [
                              _c("cargo-user-select", {
                                ref: "csr",
                                attrs: {
                                  no: "csr",
                                  "method-params": {
                                    officeId:
                                      _vm.form.salesOffice === 1
                                        ? _vm.form.opOffice
                                        : _vm.form.salesOffice,
                                    category: "role",
                                    shape: "csr"
                                  },
                                  "default-value": _vm.form.csr || "",
                                  "merge-load": true
                                },
                                on: {
                                  change: function(p) {
                                    _vm.csrChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w240",
                              attrs: { label: _vm.$t("SeaExport.Documents") }
                            },
                            [
                              _c("cargo-user-select", {
                                ref: "dc",
                                attrs: {
                                  no: "dc",
                                  "method-params": {
                                    officeId: _vm.form.opOffice,
                                    category: "role",
                                    shape: "doc"
                                  },
                                  "default-value": _vm.form.dc || "",
                                  "merge-load": true
                                },
                                on: {
                                  change: function(p) {
                                    _vm.dcChangeHandler(p)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "section",
          staticStyle: { width: "80%", "min-width": "1000px" }
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ShippingInformation")))
          ]),
          _c(
            "div",
            {
              staticClass: "form-row",
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    "label-width": "110px",
                    "label-position": "right",
                    disabled: !_vm.isEditing
                  }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { staticStyle: { width: "300px" } },
                        [
                          _vm.form.shippingType === "SE" ||
                          _vm.form.shippingType === "RE"
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w300",
                                  attrs: { "label-width": "130px" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "blue",
                                      attrs: { slot: "label" },
                                      slot: "label"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.FLCLType"))
                                      )
                                    ]
                                  ),
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "containerLoadType",
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_FbaJobConstants$CONTAINER_LOAD_TYPES,
                                      filterable: "",
                                      clearable: false,
                                      "default-value":
                                        _vm.form.containerLoadType
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.form.containerLoadType = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.form.shippingType === "AE"
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w300",
                                  attrs: { "label-width": "130px" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "blue",
                                      attrs: { slot: "label" },
                                      slot: "label"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("SeaExport.OperateType"))
                                      )
                                    ]
                                  ),
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "operateType",
                                      clearable: false,
                                      filterable: "",
                                      "select-type":
                                        _vm.selectTypeNames
                                          .local_cache_AirExportConstants$BUSINESS_MODELS,
                                      "default-value": _vm.form.operateType
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.form.operateType = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w300",
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_EstimatedAmazonArrivalTime"
                                ),
                                "label-width": "130px"
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "preAmazonWhTime",
                                  type: "date",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.form.preAmazonWhTime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "preAmazonWhTime", $$v)
                                  },
                                  expression: "form.preAmazonWhTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w300",
                              attrs: { "label-width": "130px" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.transportation"))
                                  )
                                ]
                              ),
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "" },
                                  on: { change: _vm.changeShippingType },
                                  model: {
                                    value: _vm.form.shippingType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shippingType", $$v)
                                    },
                                    expression: "form.shippingType"
                                  }
                                },
                                _vm._l(
                                  _vm.FbaJobConstants.SHIPPING_TYPES,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label:
                                          _vm.$store.getters.language === "zh"
                                            ? item.chineseName
                                            : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w300",
                              attrs: {
                                label: _vm.$t("SeaExport.POoriginalNumber"),
                                "label-width": "130px"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.poNumber,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "poNumber", $$v)
                                  },
                                  expression: "form.poNumber"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w300",
                              attrs: { "label-width": "130px" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("FbaJob.ChargingMethod"))
                                  )
                                ]
                              ),
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.chargingMethodChange },
                                  model: {
                                    value: _vm.form.chargingMethod,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "chargingMethod", $$v)
                                    },
                                    expression: "form.chargingMethod"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: "0" } }, [
                                    _vm._v(_vm._s("KG"))
                                  ]),
                                  _c("el-radio", { attrs: { label: "1" } }, [
                                    _vm._v(_vm._s("CBM"))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w300",
                              attrs: {
                                label: _vm.$t("SeaExport.PackageType"),
                                "label-width": "130px"
                              }
                            },
                            [
                              _c("cargo-packing-select", {
                                attrs: {
                                  no: "packing",
                                  "default-value": _vm.form.packing
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.packing = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w300",
                              attrs: {
                                label: _vm.$t("SeaExport.VATTaxNumber"),
                                "label-width": "130px"
                              }
                            },
                            [
                              _c("el-input", {
                                on: {
                                  change: function(p) {
                                    _vm.form.address.shipperVatNo =
                                      _vm.form.vatNo
                                    _vm.form.address.shipperVatNoType = "VAT"
                                  }
                                },
                                model: {
                                  value: _vm.form.vatNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "vatNo", $$v)
                                  },
                                  expression: "form.vatNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w300",
                              attrs: { "label-width": "130px" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [_vm._v(_vm._s(_vm.$t("FbaJob.PickupService")))]
                              ),
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.form.pickupService,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "pickupService", $$v)
                                    },
                                    expression: "form.pickupService"
                                  }
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v(_vm._s(_vm.$t("SeaExport.yes")))
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v(_vm._s(_vm.$t("SeaExport.no")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm.form.pickupService
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w300",
                                  attrs: {
                                    label: _vm.$t("SeaExport.ContactPerson"),
                                    "label-width": "130px"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.doorMan,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "doorMan", $$v)
                                      },
                                      expression: "form.doorMan"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.form.pickupService
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w300",
                                  attrs: {
                                    label: _vm.$t("SeaExport.CustomJobType"),
                                    "label-width": "130px"
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "customJobType2",
                                      filterable: "",
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_CutomJobType,
                                      "method-params": {
                                        type: _vm.form.lob,
                                        fba: true,
                                        active: true
                                      },
                                      "callback-method-type": "value",
                                      "default-value": _vm.form.customJobType,
                                      "callback-params": {
                                        key: "customJobType"
                                      },
                                      placeholder: " "
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.form.customJobType = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticStyle: { width: "280px" } },
                        [
                          !_vm.isEditing
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w280",
                                  attrs: {
                                    label: _vm.$t("SeaExport.ServiceChannel")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "serviceChannel",
                                      disabled: "",
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_FbaChannel,
                                      filterable: "",
                                      "method-params": { active: true },
                                      clearable: true,
                                      "default-value": _vm.form.serviceChannel
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.form.serviceChannel = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isEditing
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w280",
                                  attrs: {
                                    label: _vm.$t("SeaExport.ServiceChannel")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { filterable: "", clearable: "" },
                                      on: { change: _vm.changeServiceChannel },
                                      model: {
                                        value: _vm.form.serviceChannel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "serviceChannel",
                                            $$v
                                          )
                                        },
                                        expression: "form.serviceChannel"
                                      }
                                    },
                                    _vm._l(_vm.channel4JobSelect, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.channelName,
                                          value: item.channelName
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w280",
                              attrs: {
                                label: _vm.$t("SeaExport.PortOfLoadingAI")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                ref: "loadingPortCode",
                                attrs: {
                                  no: "loadingPortCode",
                                  "select-type": _vm.loadingPortType,
                                  filterable: "",
                                  "default-value": _vm.form.loadingPortCode
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.loadingPortCode = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w280",
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.DestinationDeliveryMethod"
                                )
                              }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "" },
                                  on: {
                                    change: _vm.destinationDistributionChange
                                  },
                                  model: {
                                    value: _vm.form.destinationDistribution,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "destinationDistribution",
                                        $$v
                                      )
                                    },
                                    expression: "form.destinationDistribution"
                                  }
                                },
                                _vm._l(
                                  _vm.FbaJobConstants
                                    .ORDER_DESTINATION_DISTRIBUTION_TYPES,
                                  function(item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label:
                                          _vm.$store.getters.language === "zh"
                                            ? item.chineseName
                                            : item.englishName,
                                        value: item.code
                                      }
                                    })
                                  }
                                ),
                                1
                              )
                            ],
                            1
                          ),
                          _vm.form.destinationDistribution &&
                          Number(_vm.form.destinationDistribution) === 1
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w280",
                                  attrs: {
                                    label: _vm.$t("SeaExport.CourierCompany")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        no: "expressCompany",
                                        placeholder: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.form.expressCompany,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "expressCompany",
                                            $$v
                                          )
                                        },
                                        expression: "form.expressCompany"
                                      }
                                    },
                                    _vm._l(
                                      _vm.FbaJobConstants.EXPRESS_COMPANYS,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.chineseName,
                                            value: item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w280",
                              attrs: { label: "Shipment Id" }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.shipmentId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "shipmentId", $$v)
                                  },
                                  expression: "form.shipmentId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                "margin-bottom": "2px !important"
                              },
                              attrs: {
                                label: _vm.$t("FbaJob.BubbleCountingRatio"),
                                "label-width": "60px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "60px" },
                                on: { change: _vm.bubbleCountingChange },
                                model: {
                                  value: _vm.form.bubbleCountingRatio,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "bubbleCountingRatio",
                                      $$v
                                    )
                                  },
                                  expression: "form.bubbleCountingRatio"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "5px",
                                    "margin-right": "10px"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("FbaJob.BubbleSplittingRatio")
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "60px" },
                                on: { change: _vm.bubbleSplittingRatioChange },
                                model: {
                                  value: _vm.form.bubbleSplittingRatio,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "bubbleSplittingRatio",
                                      $$v
                                    )
                                  },
                                  expression: "form.bubbleSplittingRatio"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "1px" } },
                                [_vm._v("%")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "el-form-item-w280" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.CargoType")))]
                              ),
                              _c(
                                "el-select",
                                {
                                  attrs: { filterable: "" },
                                  model: {
                                    value: _vm.form.cargoType,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "cargoType", $$v)
                                    },
                                    expression: "form.cargoType"
                                  }
                                },
                                _vm._l(_vm.cargoType4JobSelect, function(
                                  item,
                                  index
                                ) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.chineseName,
                                      value: item.code
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w280",
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.VATRegistrationCountry"
                                )
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "taxRegisterCountry",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Country,
                                  filterable: "",
                                  "callback-params": {
                                    key: "taxRegisterCountry"
                                  },
                                  "callback-method-type": "value",
                                  "default-value": _vm.form.taxRegisterCountry
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.taxRegisterCountry = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.form.pickupService
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w280",
                                  attrs: {
                                    label: _vm.$t("SeaExport.CustomJobType")
                                  }
                                },
                                [
                                  _c("cargo-advance-select", {
                                    attrs: {
                                      no: "customJobType1",
                                      filterable: "",
                                      "select-type":
                                        _vm.selectTypeNames
                                          .basic_data_CutomJobType,
                                      "method-params": {
                                        type: _vm.form.lob,
                                        fba: true,
                                        active: true
                                      },
                                      "callback-method-type": "value",
                                      "default-value": _vm.form.customJobType,
                                      "callback-params": {
                                        key: "customJobType"
                                      },
                                      placeholder: " "
                                    },
                                    on: {
                                      parentCallBack: function(p) {
                                        _vm.form.customJobType = p.value
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.form.pickupService
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w280",
                                  attrs: { label: _vm.$t("FbaJob.PickupTime") }
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      no: "pickupTime",
                                      type: "datetime",
                                      clearable: "",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                      format: "yyyy-MM-dd HH:mm"
                                    },
                                    model: {
                                      value: _vm.form.pickupTime,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pickupTime", $$v)
                                      },
                                      expression: "form.pickupTime"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.form.pickupService
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w280",
                                  attrs: { label: _vm.$t("FbaJob.DoorManTel") }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.doorManTel,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "doorManTel", $$v)
                                      },
                                      expression: "form.doorManTel"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticStyle: { width: "280px" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: {
                                label: _vm.$t("FbaJob.DomesticWarehouse")
                              }
                            },
                            [
                              _c("cargo-company-select", {
                                attrs: {
                                  "method-params": {
                                    warehouse: true,
                                    active: true
                                  },
                                  "default-value":
                                    Number(_vm.form.domesticWarehouse) || ""
                                },
                                on: {
                                  change: function(p) {
                                    _vm.form.domesticWarehouse = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "el-form-item-w290" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Destination"))
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between"
                                  }
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.form.warehouseCode,
                                        placement: "bottom-end"
                                      }
                                    },
                                    [
                                      _c("el-cascader", {
                                        attrs: {
                                          options: _vm.destinations,
                                          filterable: "",
                                          clearable: true
                                        },
                                        on: {
                                          focus: function($event) {
                                            return _vm.JobUtils.focusWarehouseCode(
                                              _vm.form
                                            )
                                          },
                                          blur: function($event) {
                                            return _vm.JobUtils.blurWarehouseCode(
                                              _vm.form
                                            )
                                          },
                                          change: function(p) {
                                            _vm.JobUtils.warehouseCodeHandler(
                                              _vm.form,
                                              p
                                            )
                                            _vm.syncConsigneeInfo()
                                            _vm.changeWarehouseCode()
                                          }
                                        },
                                        model: {
                                          value: _vm.form.warehouseCode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "warehouseCode",
                                              $$v
                                            )
                                          },
                                          expression: "form.warehouseCode"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-checkbox",
                                    {
                                      staticStyle: { "margin-left": "2px" },
                                      model: {
                                        value: _vm.form.remoteWarehouse,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "remoteWarehouse",
                                            $$v
                                          )
                                        },
                                        expression: "form.remoteWarehouse"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("SeaExport.RemoteWarehouse")
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: { label: _vm.$t("SeaExport.TradeTerms2") }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "incoTerm",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_IncoTerm,
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.form.incoTerm
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.incoTerm = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: { label: "Reference Id" }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.referenceId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "referenceId", $$v)
                                  },
                                  expression: "form.referenceId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: {
                                label: _vm.$t("SeaExport.CustomsDeclarationWay")
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "customsMethodPol",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CustomsMode,
                                  "method-params": { serviceType: 0 },
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.form.customsMethodPol
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.customsMethodPol = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                "margin-bottom": "2px !important"
                              },
                              attrs: { "label-width": "0" }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: {
                                    "margin-right": "10px",
                                    "margin-left": "20px"
                                  },
                                  model: {
                                    value: _vm.form.electric,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "electric", $$v)
                                    },
                                    expression: "form.electric"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("FbaJob.ElectricCol")) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  model: {
                                    value: _vm.form.magnetic,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "magnetic", $$v)
                                    },
                                    expression: "form.magnetic"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("FbaJob.MagneticCol")))]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  model: {
                                    value: _vm.form.powdery,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "powdery", $$v)
                                    },
                                    expression: "form.powdery"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("FbaJob.PowderyCol")))]
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  model: {
                                    value: _vm.form.liquid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "liquid", $$v)
                                    },
                                    expression: "form.liquid"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("FbaJob.LiquidCol")))]
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: {
                                label: _vm.$t("FbaJob.TaxRegisterAddress")
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.taxRegisterAddress,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "taxRegisterAddress",
                                      $$v
                                    )
                                  },
                                  expression: "form.taxRegisterAddress"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.form.pickupService
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w290",
                                  attrs: { label: _vm.$t("FbaJob.PickupDoor") }
                                },
                                [
                                  _c("cargo-repeat-value-select", {
                                    attrs: {
                                      filterable: "",
                                      "allow-create": true,
                                      clearable: "",
                                      options: _vm.doorList,
                                      "label-field": "name",
                                      "value-field": "name",
                                      "unique-field": "uuid",
                                      "match-of-repeat-value":
                                        _vm.matchOfRepeatDoor
                                    },
                                    on: { change: _vm.doorsChangeHandler },
                                    model: {
                                      value: _vm.form.pickupDoor,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pickupDoor", $$v)
                                      },
                                      expression: "form.pickupDoor"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.form.pickupService
                            ? _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w290",
                                  attrs: { label: _vm.$t("FbaJob.DoorAddress") }
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.doorAddress,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "doorAddress", $$v)
                                      },
                                      expression: "form.doorAddress"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticStyle: { width: "290px" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: { "label-width": "120px" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.EstimatedWarehouseEntrygoodArrivalTime"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  no: "preWarehousingTime",
                                  type: "datetime",
                                  clearable: "",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  format: "yyyy-MM-dd HH:mm"
                                },
                                model: {
                                  value: _vm.form.preWarehousingTime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "preWarehousingTime",
                                      $$v
                                    )
                                  },
                                  expression: "form.preWarehousingTime"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticStyle: {
                                "margin-bottom": "2px !important"
                              },
                              attrs: { "label-width": "55px" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: { slot: "label" },
                                  slot: "label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("Warehouse.DestinationCountry")
                                    )
                                  )
                                ]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "80px" },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.country,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "country", $$v)
                                  },
                                  expression: "form.country"
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  staticStyle: {
                                    "margin-left": "11px",
                                    "margin-right": "10px"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.ZIP")))]
                              ),
                              _c("el-input", {
                                staticStyle: { width: "100px" },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.zipCode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "zipCode", $$v)
                                  },
                                  expression: "form.zipCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: {
                                label: _vm.$t("SeaExport.ClientsRequirement"),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  ref: "customerRequireTip",
                                  attrs: {
                                    content: _vm.form.customerRequire,
                                    placement: "right",
                                    "open-delay": 300,
                                    trigger: "hover"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "custom-textarea",
                                    attrs: { type: "textarea", row: 3 },
                                    on: {
                                      mouseenter: function($event) {
                                        return _vm.updateTooltip(
                                          "customerRequireTip"
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.form.customerRequire,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "customerRequire",
                                          $$v
                                        )
                                      },
                                      expression: "form.customerRequire"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.CustomsClearanceMethod"
                                ),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("cargo-advance-select", {
                                attrs: {
                                  no: "customsMethodPod",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_CustomsMode,
                                  "method-params": { serviceType: 1 },
                                  filterable: "",
                                  clearable: false,
                                  "default-value": _vm.form.customsMethodPod
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.form.customsMethodPod = p.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: {
                                label: _vm.$t("SeaExport.EORIEnterpriseNumber"),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("el-input", {
                                on: {
                                  change: function(p) {
                                    _vm.form.address.shipperEoriNo =
                                      _vm.form.eoriNo
                                  }
                                },
                                model: {
                                  value: _vm.form.eoriNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "eoriNo", $$v)
                                  },
                                  expression: "form.eoriNo"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: {
                                label: _vm.$t(
                                  "SeaExport.VATCompanyEnglishName"
                                ),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.form.taxCompany,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "taxCompany", $$v)
                                  },
                                  expression: "form.taxCompany"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "el-form-item-w290",
                              attrs: {
                                label: _vm.$t("SeaExport.Remarks"),
                                "label-width": "120px"
                              }
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  ref: "remarksTip",
                                  attrs: {
                                    content: _vm.form.remarks,
                                    placement: "right",
                                    "open-delay": 300,
                                    trigger: "hover"
                                  }
                                },
                                [
                                  _c("el-input", {
                                    staticClass: "custom-textarea",
                                    attrs: { type: "textarea", row: 3 },
                                    on: {
                                      mouseenter: function($event) {
                                        return _vm.updateTooltip("remarksTip")
                                      }
                                    },
                                    model: {
                                      value: _vm.form.remarks,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "remarks", $$v)
                                      },
                                      expression: "form.remarks"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "section",
          staticStyle: { width: "80%", "min-width": "1000px" }
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.ConsigneeShipperAndNotifyInfo")))
          ]),
          _c(
            "div",
            {
              staticClass: "form-row",
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    "label-width": "90px",
                    "label-position": "right",
                    disabled: !_vm.isEditing
                  }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { staticStyle: { width: "370px" } }, [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c(
                              "el-tag",
                              {
                                staticClass: "tag-w",
                                attrs: { size: "medium" }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("baseInfo.mailingAddress.shipper")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c("div", { staticClass: "el-form-item-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "expanded-div" },
                            [
                              _c(
                                "el-form-item",
                                { staticClass: "el-form-item-w380" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        float: "right"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "shipperIdBtn",
                                            type: "primary"
                                          },
                                          on: { click: _vm.fbaCodeSearchBtn }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_SelectCommonShipper"
                                              )
                                            ) + " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            no: "shipperIdSaveBtn",
                                            type: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.saveBillAddressDialog(
                                                "shipper"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.Cargo_SaveAsCommonShipper"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w380",
                                  attrs: {
                                    label: _vm.$t("SeaExport.CompanyName")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    attrs: { no: "13" },
                                    model: {
                                      value:
                                        _vm.form.address.shipperEnterpriseName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperEnterpriseName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.address.shipperEnterpriseName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w380",
                                  attrs: {
                                    label: _vm.$t(
                                      "baseInfo.mailingAddress.contactName"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    staticStyle: { width: "110px" },
                                    attrs: { no: "14" },
                                    model: {
                                      value:
                                        _vm.form.address.shipperContactName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperContactName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.address.shipperContactName"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-left": "9px",
                                        "margin-right": "12px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Tel"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    staticStyle: { width: "125px" },
                                    attrs: { no: "15" },
                                    model: {
                                      value: _vm.form.address.shipperContactTel,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperContactTel",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.address.shipperContactTel"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w380",
                                  attrs: {
                                    label: _vm.$t("CargoMsg.Cargo_email")
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    staticStyle: { width: "110px" },
                                    attrs: { no: "16" },
                                    model: {
                                      value:
                                        _vm.form.address.shipperContactEmail,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperContactEmail",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.address.shipperContactEmail"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-left": "9px",
                                        "margin-right": "12px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Fax"))
                                      )
                                    ]
                                  ),
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    staticStyle: { width: "125px" },
                                    attrs: { no: "17" },
                                    model: {
                                      value: _vm.form.address.shipperFax,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperFax",
                                          $$v
                                        )
                                      },
                                      expression: "form.address.shipperFax"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "el-form-item-wrapper",
                                  staticStyle: { display: "flex" }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "el-form-item-w200",
                                      attrs: { label: _vm.$t("SeaExport.ZIP") }
                                    },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "uppercase",
                                            rawName: "v-uppercase"
                                          }
                                        ],
                                        staticStyle: { width: "110px" },
                                        attrs: { no: "18" },
                                        model: {
                                          value:
                                            _vm.form.address.shipperZipCode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form.address,
                                              "shipperZipCode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.address.shipperZipCode"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "el-form-item-w170",
                                      attrs: {
                                        "label-width": "45px",
                                        label: _vm.$t("CargoMsg.Cargo_Country")
                                      }
                                    },
                                    [
                                      _c("cargo-advance-select", {
                                        attrs: {
                                          no: "38",
                                          "select-type":
                                            _vm.selectTypeNames
                                              .basic_data_Country,
                                          filterable: "",
                                          "callback-params": {
                                            key: "shipperCountryCode"
                                          },
                                          "callback-method-type": "value",
                                          "default-value":
                                            _vm.form.address.shipperCountryCode
                                        },
                                        on: {
                                          parentCallBack: _vm.selectCargoItem
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w380",
                                  attrs: {
                                    label: _vm.$t(
                                      "baseInfo.mailingAddress.province"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    attrs: { no: "20" },
                                    model: {
                                      value:
                                        _vm.form.address.shipperProvinceCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperProvinceCode",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.address.shipperProvinceCode"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w380",
                                  attrs: { label: _vm.$t("route.city") }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    attrs: { no: "21" },
                                    model: {
                                      value: _vm.form.address.shipperCityCode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperCityCode",
                                          $$v
                                        )
                                      },
                                      expression: "form.address.shipperCityCode"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w380",
                                  attrs: {
                                    label: _vm.$t(
                                      "baseInfo.mailingAddress.addr1"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    attrs: { no: "22" },
                                    model: {
                                      value: _vm.form.address.shipperAddress1,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperAddress1",
                                          $$v
                                        )
                                      },
                                      expression: "form.address.shipperAddress1"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w380",
                                  attrs: {
                                    label: _vm.$t(
                                      "baseInfo.mailingAddress.addr2"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    attrs: { no: "23" },
                                    model: {
                                      value: _vm.form.address.shipperAddress2,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperAddress2",
                                          $$v
                                        )
                                      },
                                      expression: "form.address.shipperAddress2"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w380",
                                  attrs: {
                                    label: _vm.$t(
                                      "baseInfo.mailingAddress.addr3"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    attrs: { no: "24" },
                                    model: {
                                      value: _vm.form.address.shipperAddress3,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperAddress3",
                                          $$v
                                        )
                                      },
                                      expression: "form.address.shipperAddress3"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w380",
                                  attrs: {
                                    label: _vm.$t(
                                      "baseInfo.mailingAddress.eoriNo"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    attrs: { no: "25" },
                                    model: {
                                      value: _vm.form.address.shipperEoriNo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperEoriNo",
                                          $$v
                                        )
                                      },
                                      expression: "form.address.shipperEoriNo"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "el-form-item-w380",
                                  attrs: {
                                    label: _vm.$t(
                                      "baseInfo.mailingAddress.taxNo"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    directives: [
                                      {
                                        name: "uppercase",
                                        rawName: "v-uppercase"
                                      }
                                    ],
                                    staticStyle: { width: "210px" },
                                    model: {
                                      value: _vm.form.address.shipperVatNo,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.address,
                                          "shipperVatNo",
                                          $$v
                                        )
                                      },
                                      expression: "form.address.shipperVatNo"
                                    }
                                  }),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: {
                                        width: "70px",
                                        "padding-left": "2px"
                                      },
                                      attrs: { placeholder: "", no: "26" },
                                      model: {
                                        value:
                                          _vm.form.address.shipperVatNoType,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "shipperVatNoType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.shipperVatNoType"
                                      }
                                    },
                                    _vm._l(
                                      _vm.SystemConstants.VAT_NO_TYPES,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.code,
                                          attrs: {
                                            label: item.code,
                                            value: item.code
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _c(
                        "el-col",
                        { staticStyle: { width: "370px" } },
                        [
                          _c(
                            "el-tag",
                            { staticClass: "tag-w", attrs: { size: "medium" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("baseInfo.mailingAddress.consignee")
                                )
                              )
                            ]
                          ),
                          _c("div", { staticClass: "el-form-item-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "expanded-div" },
                              [
                                _c(
                                  "el-form-item",
                                  { staticClass: "el-form-item-w380" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          float: "right"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "vertical-align": "top"
                                            },
                                            attrs: {
                                              no: "consigneeIdBtn",
                                              type: "primary"
                                            },
                                            on: { click: _vm.fbaCodeSearchBtn }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_SelectCommonConsignee"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              no: "consigneeIdSaveBtn",
                                              type: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.saveBillAddressDialog(
                                                  "consignee"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_SaveAsCommonConsignee"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t("SeaExport.CompanyName")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "32" },
                                      model: {
                                        value:
                                          _vm.form.address
                                            .consigneeEnterpriseName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeEnterpriseName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeEnterpriseName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.contactName"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      staticStyle: { width: "110px" },
                                      attrs: { no: "14" },
                                      model: {
                                        value:
                                          _vm.form.address.consigneeContactName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeContactName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeContactName"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-left": "9px",
                                          "margin-right": "12px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("CargoMsg.Cargo_Tel"))
                                        )
                                      ]
                                    ),
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      staticStyle: { width: "125px" },
                                      attrs: { no: "15" },
                                      model: {
                                        value:
                                          _vm.form.address.consigneeContactTel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeContactTel",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeContactTel"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_email")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      staticStyle: { width: "110px" },
                                      attrs: { no: "16" },
                                      model: {
                                        value:
                                          _vm.form.address
                                            .consigneeContactEmail,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeContactEmail",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeContactEmail"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-left": "9px",
                                          "margin-right": "12px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("CargoMsg.Cargo_Fax"))
                                        )
                                      ]
                                    ),
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      staticStyle: { width: "125px" },
                                      attrs: { no: "17" },
                                      model: {
                                        value: _vm.form.address.consigneeFax,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeFax",
                                            $$v
                                          )
                                        },
                                        expression: "form.address.consigneeFax"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "el-form-item-wrapper",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "el-form-item-w200",
                                        attrs: {
                                          label: _vm.$t("SeaExport.ZIP")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticStyle: { width: "110px" },
                                          attrs: { no: "18" },
                                          model: {
                                            value:
                                              _vm.form.address.consigneeZipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form.address,
                                                "consigneeZipCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.address.consigneeZipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "el-form-item-w170",
                                        attrs: {
                                          "label-width": "45px",
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_Country"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          attrs: {
                                            no: "38",
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Country,
                                            filterable: "",
                                            "callback-params": {
                                              key: "consigneeCountryCode"
                                            },
                                            "callback-method-type": "value",
                                            "default-value":
                                              _vm.form.address
                                                .consigneeCountryCode
                                          },
                                          on: {
                                            parentCallBack: _vm.selectCargoItem
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.province"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "39" },
                                      model: {
                                        value:
                                          _vm.form.address
                                            .consigneeProvinceName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeProvinceName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeProvinceName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: { label: _vm.$t("route.city") }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "40" },
                                      model: {
                                        value:
                                          _vm.form.address.consigneeCityName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeCityName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeCityName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.addr1"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "41" },
                                      model: {
                                        value:
                                          _vm.form.address.consigneeAddress1,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeAddress1",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeAddress1"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.addr2"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "42" },
                                      model: {
                                        value:
                                          _vm.form.address.consigneeAddress2,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeAddress2",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeAddress2"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.addr3"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "43" },
                                      model: {
                                        value:
                                          _vm.form.address.consigneeAddress3,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeAddress3",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeAddress3"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.eoriNo"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "44" },
                                      model: {
                                        value: _vm.form.address.consigneeEoriNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeEoriNo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeEoriNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.taxNo"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      staticStyle: { width: "210px" },
                                      attrs: { no: "45" },
                                      model: {
                                        value: _vm.form.address.consigneeVatNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "consigneeVatNo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.consigneeVatNo"
                                      }
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: {
                                          width: "70px",
                                          "padding-left": "2px"
                                        },
                                        attrs: { placeholder: "", no: "46" },
                                        model: {
                                          value:
                                            _vm.form.address.consigneeVatNoType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form.address,
                                              "consigneeVatNoType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.address.consigneeVatNoType"
                                        }
                                      },
                                      _vm._l(
                                        _vm.SystemConstants.VAT_NO_TYPES,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.code,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticStyle: { width: "370px" } },
                        [
                          _c(
                            "el-tag",
                            { staticClass: "tag-w", attrs: { size: "medium" } },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("baseInfo.mailingAddress.notify"))
                              )
                            ]
                          ),
                          _c("div", { staticClass: "el-form-item-wrapper" }, [
                            _c(
                              "div",
                              { staticClass: "expanded-div" },
                              [
                                _c(
                                  "el-form-item",
                                  { staticClass: "el-form-item-w380" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          float: "right"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              "vertical-align": "top"
                                            },
                                            attrs: {
                                              no: "notifyIdBtn",
                                              type: "primary"
                                            },
                                            on: { click: _vm.fbaCodeSearchBtn }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_SelectCommonNotifier"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              no: "notifyIdSaveBtn",
                                              type: "primary"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.saveBillAddressDialog(
                                                  "notify"
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_SaveAsCommonNotifier"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t("SeaExport.CompanyName")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "52" },
                                      model: {
                                        value:
                                          _vm.form.address.notifyEnterpriseName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyEnterpriseName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.notifyEnterpriseName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.contactName"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      staticStyle: { width: "110px" },
                                      attrs: { no: "14" },
                                      model: {
                                        value:
                                          _vm.form.address.notifyContactName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyContactName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.notifyContactName"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-left": "9px",
                                          "margin-right": "12px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("CargoMsg.Cargo_Tel"))
                                        )
                                      ]
                                    ),
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      staticStyle: { width: "125px" },
                                      attrs: { no: "15" },
                                      model: {
                                        value:
                                          _vm.form.address.notifyContactTel,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyContactTel",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.notifyContactTel"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_email")
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      staticStyle: { width: "110px" },
                                      attrs: { no: "16" },
                                      model: {
                                        value:
                                          _vm.form.address.notifyContactEmail,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyContactEmail",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.notifyContactEmail"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-left": "9px",
                                          "margin-right": "12px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("CargoMsg.Cargo_Fax"))
                                        )
                                      ]
                                    ),
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      staticStyle: { width: "125px" },
                                      attrs: { no: "17" },
                                      model: {
                                        value: _vm.form.address.notifyFax,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyFax",
                                            $$v
                                          )
                                        },
                                        expression: "form.address.notifyFax"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "el-form-item-wrapper",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "el-form-item-w200",
                                        attrs: {
                                          label: _vm.$t("SeaExport.ZIP")
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "uppercase",
                                              rawName: "v-uppercase"
                                            }
                                          ],
                                          staticStyle: { width: "110px" },
                                          attrs: { no: "18" },
                                          model: {
                                            value:
                                              _vm.form.address.notifyZipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form.address,
                                                "notifyZipCode",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.address.notifyZipCode"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "el-form-item-w170",
                                        attrs: {
                                          "label-width": "45px",
                                          label: _vm.$t(
                                            "CargoMsg.Cargo_Country"
                                          )
                                        }
                                      },
                                      [
                                        _c("cargo-advance-select", {
                                          attrs: {
                                            no: "38",
                                            "select-type":
                                              _vm.selectTypeNames
                                                .basic_data_Country,
                                            filterable: "",
                                            "callback-params": {
                                              key: "notifyCountryCode"
                                            },
                                            "callback-method-type": "value",
                                            "default-value":
                                              _vm.form.address.notifyCountryCode
                                          },
                                          on: {
                                            parentCallBack: _vm.selectCargoItem
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.province"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "59" },
                                      model: {
                                        value:
                                          _vm.form.address.notifyProvinceCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyProvinceCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.notifyProvinceCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: { label: _vm.$t("route.city") }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "60" },
                                      model: {
                                        value: _vm.form.address.notifyCityCode,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyCityCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.notifyCityCode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.addr1"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "61" },
                                      model: {
                                        value: _vm.form.address.notifyAddress1,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyAddress1",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.notifyAddress1"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.addr2"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "62" },
                                      model: {
                                        value: _vm.form.address.notifyAddress2,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyAddress2",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.notifyAddress2"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.addr3"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "63" },
                                      model: {
                                        value: _vm.form.address.notifyAddress3,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyAddress3",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.address.notifyAddress3"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.eoriNo"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      attrs: { no: "64" },
                                      model: {
                                        value: _vm.form.address.notifyEoriNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyEoriNo",
                                            $$v
                                          )
                                        },
                                        expression: "form.address.notifyEoriNo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "el-form-item-w380",
                                    attrs: {
                                      label: _vm.$t(
                                        "baseInfo.mailingAddress.taxNo"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      directives: [
                                        {
                                          name: "uppercase",
                                          rawName: "v-uppercase"
                                        }
                                      ],
                                      staticStyle: { width: "210px" },
                                      attrs: { no: "65" },
                                      model: {
                                        value: _vm.form.address.notifyVatNo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form.address,
                                            "notifyVatNo",
                                            $$v
                                          )
                                        },
                                        expression: "form.address.notifyVatNo"
                                      }
                                    }),
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: {
                                          width: "70px",
                                          "padding-left": "2px"
                                        },
                                        attrs: { no: "66", placeholder: "" },
                                        model: {
                                          value:
                                            _vm.form.address.notifyVatNoType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form.address,
                                              "notifyVatNoType",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.address.notifyVatNoType"
                                        }
                                      },
                                      _vm._l(
                                        _vm.SystemConstants.VAT_NO_TYPES,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.code,
                                              value: item.code
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "section",
          staticStyle: { width: "80%", "min-width": "1000px" }
        },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo2")))
          ]),
          _c(
            "div",
            {
              staticClass: "form-row grid-list",
              staticStyle: { "min-width": "1000px" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { "label-width": "100px", "label-position": "left" }
                },
                [
                  _c(
                    "el-form",
                    { staticClass: "spacing" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.goodsViewType,
                            callback: function($$v) {
                              _vm.goodsViewType = $$v
                            },
                            expression: "goodsViewType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: "detail" } }, [
                            _vm._v(_vm._s(_vm.$t("Warehouse.Detail")))
                          ]),
                          _c("el-radio", { attrs: { label: "summary" } }, [
                            _vm._v(_vm._s(_vm.$t("Warehouse.Summary")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    { staticClass: "spacing" },
                    [
                      !_vm.goodsViewSummary
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                disabled: !_vm.isEditing,
                                type: "primary"
                              },
                              on: { click: _vm.addDetailHandler }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("Warehouse.AddCargo")) + " "
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-dropdown",
                        {
                          staticStyle: { margin: "0 5px" },
                          attrs: {
                            no: "exportOrderHandle",
                            "split-button": "",
                            type: "primary",
                            disabled:
                              _vm.isEditing || _vm.isChecking || _vm.isVerify
                          },
                          on: {
                            click: function($event) {
                              return _vm.exportOrderHandle()
                            }
                          }
                        },
                        [
                          _vm.exportOrderCommand ===
                          this.$t("CargoMsg.Cargo_DownloadTemplate")
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.exportOrderCommand))
                              ])
                            : _vm._e(),
                          [
                            _vm.$t("SeaExport.batchImport"),
                            _vm.$t("SeaExport.GoodsInformationImport")
                          ].includes(_vm.exportOrderCommand)
                            ? _c(
                                "el-upload",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    "margin-left": "5px"
                                  },
                                  attrs: {
                                    action: _vm.URL.fba.batchImport,
                                    headers: _vm.headers,
                                    "show-file-list": false,
                                    accept: ".xls, .xlsx",
                                    "before-upload": _vm.beforeOrderUpload,
                                    "on-success": _vm.uploadOrderSuccess,
                                    "on-error": _vm.handleError,
                                    data: { uuid: _vm.form.uuid },
                                    disabled: _vm.isEditing || _vm.isChecking
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "white" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          [
                                            _vm.$t("SeaExport.batchImport"),
                                            _vm.$t(
                                              "SeaExport.GoodsInformationImport"
                                            )
                                          ].includes(_vm.exportOrderCommand)
                                            ? _vm.exportOrderCommand
                                            : ""
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "SeaExport.GoodsInformationImport"
                                    )
                                  }
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      ref: "uploadOrder",
                                      staticStyle: { display: "inline-block" },
                                      attrs: {
                                        action: _vm.URL.fba.batchImport,
                                        headers: _vm.headers,
                                        "show-file-list": false,
                                        accept: ".xls, .xlsx",
                                        "before-upload": _vm.beforeOrderUpload,
                                        "on-success": _vm.uploadOrderSuccess,
                                        "on-error": _vm.handleError,
                                        data: { uuid: _vm.form.uuid }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "padding-left": "0px",
                                            color: "#6F6F6F",
                                            "text-align": "left",
                                            width: "80px"
                                          },
                                          attrs: {
                                            slot: "trigger",
                                            type: "text"
                                          },
                                          slot: "trigger"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "SeaExport.GoodsInformationImport"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-dropdown-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "padding-left": "0px",
                                        color: "#6F6F6F",
                                        "text-align": "left",
                                        width: "80px"
                                      },
                                      attrs: { no: "16", type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.downLoadDetail()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_DownLoad_Detail"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-dropdown-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "padding-left": "0px",
                                        color: "#6F6F6F",
                                        "text-align": "left",
                                        width: "80px"
                                      },
                                      attrs: { no: "16", type: "text" },
                                      on: {
                                        click: function($event) {
                                          return _vm.downLoadSummary()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_DownLoad_Summary"
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", disabled: !_vm.isEditing },
                          on: { click: _vm.batchAddHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Warehouse.BatchMaintenance")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", disabled: !_vm.isEditing },
                          on: { click: _vm.delAllHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.emptyDestinationInformation")
                            )
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger", disabled: !_vm.isEditing },
                          on: { click: _vm.delDetailHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Warehouse.DeleteCargo")))]
                      )
                    ],
                    1
                  ),
                  !_vm.goodsViewSummary
                    ? _c("cargo-ag-grid", {
                        ref: "goodsDetailTable",
                        staticStyle: { height: "200px" },
                        attrs: {
                          "config-module": "93000021",
                          "grid-options": _vm.detailList.goodGridOptions,
                          "column-defs": _vm.dynamicGoodsColumnDefs,
                          "row-data": _vm.form.goods || []
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.detailList.gridApi = params.api
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.goodsViewSummary
                    ? _c("cargo-ag-grid", {
                        ref: "goodsSummaryTable",
                        staticStyle: { height: "200px" },
                        attrs: {
                          "config-module": "93000020",
                          "grid-options": _vm.detailList.goodGridOptions,
                          "column-defs": _vm.dynamicGoodsColumnDefs,
                          "row-data": _vm.summaryGoodsDetailList || []
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.detailList.gridApi = params.api
                          }
                        }
                      })
                    : _vm._e(),
                  _c(
                    "el-form",
                    {
                      staticClass: "spacing",
                      attrs: { "label-position": "left" }
                    },
                    [
                      _c("span", { staticStyle: { "margin-right": "4px" } }, [
                        _vm._v(_vm._s(_vm.$t("FbaJob.QuantityContract")))
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.quantityContract,
                            expression: "quantityContract"
                          }
                        ],
                        staticStyle: {
                          height: "28px",
                          width: "96px",
                          "text-align": "right"
                        },
                        attrs: { disabled: !_vm.isEditing },
                        domProps: { value: _vm.quantityContract },
                        on: {
                          change: _vm.changeQuantity,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.quantityContract = $event.target.value
                          }
                        }
                      }),
                      _c("span", { staticStyle: { "margin-left": "4px" } }, [
                        _vm._v("PCS")
                      ]),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "12px",
                            "margin-right": "4px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("FbaJob.WeightContract")))]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.weightContract,
                            expression: "weightContract"
                          }
                        ],
                        staticStyle: {
                          height: "28px",
                          width: "96px",
                          "text-align": "right"
                        },
                        attrs: { disabled: !_vm.isEditing },
                        domProps: { value: _vm.weightContract },
                        on: {
                          change: _vm.changeWeight,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.weightContract = $event.target.value
                          }
                        }
                      }),
                      _c("span", { staticStyle: { "margin-left": "4px" } }, [
                        _vm._v("KGS")
                      ]),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "12px",
                            "margin-right": "4px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("FbaJob.CubageContract")))]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.cubageContract,
                            expression: "cubageContract"
                          }
                        ],
                        staticStyle: {
                          height: "28px",
                          width: "96px",
                          "text-align": "right"
                        },
                        attrs: { disabled: !_vm.isEditing },
                        domProps: { value: _vm.cubageContract },
                        on: {
                          change: _vm.changeCubage,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.cubageContract = $event.target.value
                          }
                        }
                      }),
                      _c("span", { staticStyle: { "margin-left": "4px" } }, [
                        _vm._v("CBM")
                      ]),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "12px",
                            "margin-right": "4px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("FbaJob.VolumetricWeight")))]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.volumetricWeightContract,
                            expression: "volumetricWeightContract"
                          }
                        ],
                        staticStyle: {
                          height: "28px",
                          width: "96px",
                          "text-align": "right"
                        },
                        attrs: { disabled: !_vm.isEditing },
                        domProps: { value: _vm.volumetricWeightContract },
                        on: {
                          change: _vm.changeVolumetricWeight,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.volumetricWeightContract = $event.target.value
                          }
                        }
                      }),
                      _c("span", { staticStyle: { "margin-left": "4px" } }, [
                        _vm._v("KGS")
                      ]),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "12px",
                            "margin-right": "4px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("FbaJob.ChargedWeight")))]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.chargeWeightContract,
                            expression: "chargeWeightContract"
                          }
                        ],
                        staticStyle: {
                          height: "28px",
                          width: "96px",
                          "text-align": "right"
                        },
                        attrs: { disabled: !_vm.isEditing },
                        domProps: { value: _vm.chargeWeightContract },
                        on: {
                          change: _vm.changeChargeWeight,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.chargeWeightContract = $event.target.value
                          }
                        }
                      }),
                      _c("span", { staticStyle: { "margin-left": "4px" } }, [
                        _vm._v("KGS")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.form,
          "customer-cmp-list": _vm.customerCmpList,
          fba: true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _vm.containerNoEditor.visible
        ? _c("container-no-editor", {
            attrs: {
              "boxes-number": _vm.containerNoEditor.boxesNumber,
              visible: _vm.containerNoEditor.visible,
              "shipment-id": _vm.containerNoEditor.shipmentId,
              source: _vm.goodsViewType,
              "container-no": _vm.containerNoEditor.containerNo,
              "warehouse-in-detail-list": _vm.form.goods
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.containerNoEditor, "visible", $event)
              },
              summarySaveCallBack: _vm.containerNoEditor.summarySaveCallBack,
              detailSaveCallBack: _vm.containerNoEditor.detailSaveCallBack,
              close: function($event) {
                _vm.containerNoEditor.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.batchMaintenanceDialog.visible
        ? _c("batch-maintenance-dialog", {
            attrs: {
              visible: _vm.batchMaintenanceDialog.visible,
              "exist-detail-list": _vm.form.goods
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchMaintenanceDialog, "visible", $event)
              },
              saveCallBack: _vm.batchMaintenanceDialog.saveCallBack,
              close: function($event) {
                _vm.batchMaintenanceDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }